import { render, staticRenderFns } from "./Step23.vue?vue&type=template&id=0ac3781a&scoped=true"
import script from "./Step23.vue?vue&type=script&lang=js"
export * from "./Step23.vue?vue&type=script&lang=js"
import style0 from "./Step23.vue?vue&type=style&index=0&id=0ac3781a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3781a",
  null
  
)

export default component.exports